module.exports = __webpack_public_path__ + "static/media/WarningIcon.73ac3132.svg";